import { isCached } from '~/utils/helpers';
import { useLiteSidebarStore } from '~/stores/liteSidebarStore';
import { getCustomPageData } from '~/utils/dataProviders/CustomPageApiDataProvider';
import { useAccountStore } from '~/stores/accountStore';
import { LITE_SIDEBAR_SLUG } from '~/utils/constants';
import { customPageSidebar as customPageSidebarMock } from '~/server/mocks/sidebar';
import type { CustomPageSidebar } from '~/types/adminApi';
import { handleRequestWithMock } from '~/composables/handleRequestWithMock';

export async function loadLiteSidebar(): Promise<void> {
    const store = useLiteSidebarStore();
    const { id } = useAccountStore().state;

    if (isCached(store.state.loadedAt)) {
        return;
    }

    try {
        const sidebar = await handleRequestWithMock<CustomPageSidebar>(
            () => getCustomPageData(id, LITE_SIDEBAR_SLUG),
            customPageSidebarMock
        );

        store.setLiteSidebarState({
            title: sidebar.title,
            content: sidebar.description,
            loadedAt: Date.now(),
        });
    } catch {
        return;
    }
}

